import { render, staticRenderFns } from "./OnboardingTrafficProgress.vue?vue&type=template&id=09345670&scoped=true&lang=pug"
import script from "./OnboardingTrafficProgress.vue?vue&type=script&lang=ts"
export * from "./OnboardingTrafficProgress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09345670",
  null
  
)

export default component.exports